import React from "react";
import "./styles.scss";
import { Modal, ProgressBar } from "react-bootstrap";
import { indexMedia, createMedium } from "../../../../../../api/media";
import { connect } from "react-redux";
import { log_error } from "../../../../../../api";
import _ from "lodash";
import FullPageSpinner from "../../../../../FullPageSpinner";
import { object_url, getCurrentUser } from "../../../../../../api/helper";
import { uploadMedia } from "../../../../../../api/aws_s3";
import {
  isWithinImageSizeLimit,
  IMAGE_SIZE_LIMIT
} from "../../../../../shared/viewsHelper";

class ImagePicker extends React.Component {
  state = {
    show: false,
    images: null,
    selectedImages: null,
    progress: null,
    error: null
  };
  handleClick = e =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidUpdate = (prevProps, prevState) => {
    if (
      (_.isNull(this.state.selectedImages) ||
        prevProps.current_user !== this.props.current_user) &&
      this.props.current_user &&
      this.props.current_user.artist_profile
    )
      this.setState({
        selectedImages: this.props.current_user.artist_profile.images.map(
          i => i.id
        )
      });
  };
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  handleClose = () => this.setState({ show: false });
  handleShow = () => {
    this.updateList();
    this.setState({ show: true });
  };
  updateList = async () => {
    try {
      let {
        data: { media }
      } = await indexMedia({
        filter: { type: "Image", user_id: this.props.current_user.id },
        sort: "-id"
      });
      this.setState({ images: media });
    } catch (error) {
      console.log(log_error(error));
    }
  };
  uploadImage = async () => {
    try {
      this.setState({ images: null });
      if (!this.fileInput.current.files[0]) {
        this.setState({ error: "Select a file" });
        return;
      }
      if (!isWithinImageSizeLimit(this.fileInput.current.files.item(0))) {
        this.setState({
          error: `Maximum file size is ${IMAGE_SIZE_LIMIT}MB`
        });
        return;
      }
      let s3_object_key = object_url();
      await uploadMedia(
        this.fileInput.current.files[0],
        this.fileInput.current.files[0].type,
        getCurrentUser().id,
        s3_object_key,
        e => {
          this.setState({
            progress: (e.loaded * 100) / e.total
          });
        }
      );
      await createMedium({
        media: {
          s3_object_key,
          type: "Image"
        }
      });
    } catch (error) {
      console.log(log_error(error));
    } finally {
      this.updateList();
      this.setState({ progress: null });
    }
  };
  onSubmit = () => {
    this.props.onSubmit(this.state.selectedImages);
    this.handleClose();
  };
  imgClick = id => {
    let currentlySelected = this.state.selectedImages;
    if (currentlySelected.length === 3 && !currentlySelected.includes(id)) {
      currentlySelected.shift();
      console.log("currentlySelected", currentlySelected);
      this.setState({ selectedImages: currentlySelected });
      this.imgClick(id);
    } else {
      let ret = currentlySelected.includes(id)
        ? currentlySelected.filter(a => a !== id)
        : [...currentlySelected, id];
      console.log("ret", ret);
      this.setState({ selectedImages: ret });
    }
  };
  fileInput = React.createRef();
  hocWrapper = React.createRef();
  render() {
    return (
      <>
        <div ref={this.hocWrapper} className="hor_click">
          {this.props.children}
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Body>
            <Modal.Title>Pick/Upload an image</Modal.Title>
            <div className="row">
              <div className="col-auto multi-image-selector">
                {_.isNull(this.state.images) ? (
                  <FullPageSpinner />
                ) : this.state.images.length ? (
                  this.state.images.map(img => (
                    <div
                      className={`option ${
                        this.state.selectedImages.includes(img.id)
                          ? "selected"
                          : ""
                      }`}
                    >
                      <img
                        alt=""
                        src={img.url}
                        onClick={() => this.imgClick(img.id)}
                      />
                    </div>
                  ))
                ) : (
                  <p>You have no uploaded images</p>
                )}
              </div>
              <div className="col">
                <div className="form-group">
                  <label htmlFor="fileInput">
                    {this.state.error && (
                      <span className="text-danger"> {this.state.error}</span>
                    )}
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control-file"
                    onChange={this.uploadImage}
                    ref={this.fileInput}
                    onClick={() => {
                      this.setState({ error: null });
                    }}
                  />
                </div>
                {!_.isNull(this.state.progress) && (
                  <ProgressBar now={this.state.progress} />
                )}
              </div>
            </div>
            <Modal.Footer className="mt-2">
              <button className="btn" onClick={this.handleClose}>
                Cancel
              </button>
              <button className="btn btn-success" onClick={this.onSubmit}>
                Select
              </button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default connect(a => a)(ImagePicker);
